import { render, staticRenderFns } from "./AprobarAnticipoAprobado.vue?vue&type=template&id=0087e493"
import script from "./AprobarAnticipoAprobado.vue?vue&type=script&lang=js"
export * from "./AprobarAnticipoAprobado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports